// CompetitionDetails.js
import React from "react";

export function AlgorithmChallengeDetails() {
  return (
    <div>
      <h2>Algorithm</h2>
      <br></br>
      <h3>Participation</h3>
      <ul>
        <li>
          Open to students from Grade 6–13 of Royal College and other schools.
        </li>
        <li>
          Individual participation only. Team entries are not permitted.
        </li>
        <li>
          Registration for the competition must be completed before the announced deadline.
        </li>
        <li>
          All solutions must be the participant's own work. Code plagiarism, sharing solutions, or copying another participant's work will result in immediate disqualification.
        </li>
      </ul>
      <br></br>
      <h3>Competition Format</h3>
      <ul>
        <li>Hosted online through the HackerRank platform.</li>
        <li>
          Five algorithmic problems will be released simultaneously.
        </li>
        <li>
          Each problem carries 100 points, for a total of 500 points.
        </li>
        <li>
          Participants will have four hours to solve as many problems as possible.
        </li>
        <li>Submissions are accepted in C++, Python, Java, or JavaScript.</li>
        <li>Multiple attempts may be submitted for each problem.</li>
        <li>This is a single-round competition.</li>
        <li>
          Final date, time, HackerRank link, and other details will be communicated through the official BTUI'26 channels and WhatsApp group.
        </li>
      </ul>
      <br></br>
      <h3>Scoring & Ranking</h3>
      <ul>
        <li>
          Partial scoring will be available based on successfully passed test cases/subtasks.
        </li>
        <li>
          For multiple attempts, only the highest-scoring submission for that problem will count.
        </li>
        <li>
          There is no penalty for incorrect submissions.
        </li>
        <li>
          The total score across all 5 problems will decide the rankings of each contestant.
        </li>
        <li>
          In the event of a tie, the participant who achieved their final total score earliest will rank higher.
        </li>
        <li>The decisions of the judging panel will be final.</li>
      </ul>
      <br></br>
      <h3>Submission</h3>
      <ul>
        <li>
          All solutions must be submitted directly through HackerRank before the competition closes.
        </li>
        <li>
          No separate submission through the BTUI'26 website is required.
        </li>
      </ul>
    </div>
  );
}

export function ProblemSolvingDetails() {
  return (
    <div>
      <h2>Real-World Problem Solving</h2>
      <br></br>
      <h3>Participation</h3>
      <ul>
        <li>
          Open to students from Grade 6–13 of Royal College and other schools.
        </li>
        <li>
          Team participation only, with a maximum of 4 members from the same school.
        </li>
        <li>
          Each participant may be part of only one team.
        </li>
        <li>
          Registration must be completed before the announced deadline.
        </li>
        <li>
          All work must be completed by the registered team members. Plagiarism, sharing solutions between teams, or unauthorized collaboration will result in disqualification.
        </li>
      </ul>
      <br></br>

      <h3>Competition Format</h3>
      <ul>
        <li>
          Teams will receive a pre-existing codebase containing known bugs, errors, and functionality issues.
        </li>
        <li>
          Issue documentation will be provided with information and guidance regarding the problems.
        </li>
        <li>
          Teams must identify, debug, and fix as many issues as possible.
        </li>
        <li>
          A strict 4-hour time limit will apply.
        </li>
        <li>
          Teams may use suitable IDEs, debugging tools, browser developer tools, and permitted documentation/resources.
        </li>
        <li>
          All fixes must be committed and pushed to the designated GitHub repository.
        </li>
        <li>
          This is a single-round competition.
        </li>
      </ul>
      <br></br>

      <h3>Evaluation</h3>
      <p>Projects will be evaluated based on:</p>
      <ul>
        <li>
          <strong>Issues Resolved</strong> – Number and complexity of bugs fixed.
        </li>
        <li>
          <strong>Functionality Restoration</strong> – How well the application functions after the fixes.
        </li>
        <li>
          <strong>Code Quality</strong> – Cleanliness, maintainability, and good development practices.
        </li>
        <li>
          <strong>Problem-Solving Approach</strong> – Effectiveness and systematic debugging.
        </li>
        <li>
          <strong>Documentation & Commits</strong> – Quality of documentation and commit messages.
        </li>
        <li>The judging panel's decision will be final.</li>
      </ul>
      <br></br>

      <h3>Submission</h3>
      <ul>
        <li>
          The designated GitHub repository will serve as the official submission.
        </li>
        <li>
          All final changes must be committed and pushed before the 4-hour deadline.
        </li>
        <li>
          Commits made after the deadline will not be considered.
        </li>
        <li>
          A brief summary of the major issues resolved must be included in the README.md file.
        </li>
        <li>
          No separate submission through the BTUI'26 website is required.
        </li>
      </ul>
    </div>
  );
}

export function WebDevChallengeDetails() {
  return (
    <div>
      <h2>Web Development</h2>
      <br></br>
      <h3>Participation</h3>
      <ul>
        <li>
          Students from Grade 6–13 of Royal College and other schools are
          eligible to participate.
        </li>
        <li>Individual participation only—team entries are not accepted.</li>
        <li>
          Registration for the competition must be completed by the specified
          deadline.
        </li>
        <li>
          All submissions must represent original work. Copying existing
          solutions or plagiarizing content will result in disqualification.
        </li>
      </ul>
      <br></br>

      <h3>Statement</h3>
      <p>
        With dozens of events happening across the year—debates, sports meets,
        exhibitions—the administration is struggling to keep everyone updated.
        Bob is tasked with building a digital command center for all school
        events: a place where students, teachers, and parents can stay informed
        and engaged. Develop a web platform that includes:
      </p>
      <ul>
        <li>Announcements & event pages.</li>
        <li>Interactive calendars & countdowns</li>
        <li>Online registrations / ticketing.</li>
        <li>Optional: live event updates or highlights.</li>
      </ul>
      <p>
        <strong>Challenge:</strong> Creating a scalable, interactive system that
        can handle multiple events smoothly with a clean user experience.
      </p>
      <br></br>
      <h3>Instructions</h3>
      <ul>
        <li>
          Participants are required to develop a fully functional web
          application.
        </li>
        <li>
          Solutions may include interactive interfaces (web, desktop, or GUI),
          data processing, and visual outputs.
        </li>
        <li>
          Participants are free to use any suitable programming environment
          (HTML/CSS/JS, React, Angular, Vue.js, etc.).
        </li>
        <li>
          The final web application must be hosted online, using platforms such
          as GitHub Pages, Netlify, Vercel, or similar services.
        </li>
        <li>
          A README.md file must accompany the project repository, clearly
          documenting:
          <ul>
            <li>Project purpose and objectives</li>
            <li>Technologies and frameworks used</li>
            <li>Step-by-step instructions to run or access the project</li>
          </ul>
        </li>
        <li>This is held as a single-round competition</li>
      </ul>
      <br></br>
      <h3>Evaluation & Scoring</h3>
      <p>
        The submitted project will be evaluated on its ability to creatively and
        effectively solve the given challenge. The evaluation criteria are:
      </p>
      <ul>
        <li>
          <strong>Functionality</strong> – Does the application perform all
          required tasks correctly and efficiently?
        </li>
        <li>
          <strong>Design & User Experience</strong> – How intuitive, engaging,
          and visually appealing is the interface?
        </li>
        <li>
          <strong>Creativity & Innovation</strong> – Does the solution
          demonstrate original ideas, unique features, or creative approaches?
        </li>
        <li>
          <strong>Code Structure & Quality</strong> – Is the code clean,
          organized, and maintainable?
        </li>
        <li>
          Adding backend functionality, such as databases or APIs, will be
          considered a bonus and can improve scoring.
        </li>
        <li>
          Multiple submissions are not allowed. Only the first submitted version
          will be evaluated.
        </li>
      </ul>
      <br></br>
      <h3>Submission</h3>
      <ul>
        <li>
          Submit a public GitHub repository link containing the project code
          through the official BTUI'26 website. (must submit before the
          deadline. Any modifications made after the deadline will not be
          considered.)
        </li>
        <li>Provide a hosted link to the live web application.</li>
        <li>
          Ensure all links are accessible and fully functional before the
          deadline.
        </li>
      </ul>
    </div>
  );
}

export function PhotoManipulationDetails() {
  return (
    <div>
      <h2>Photo Manipulation</h2>
      <br></br>
      <h3>Overview</h3>
      <p>
        Step into a futuristic digital world where neon lights illuminate a vast
        cyber landscape. The Photo Manipulation Competition invites participants
        to explore imagination, technical skill, and artistic storytelling to
        create visually striking digital artwork inspired by a high-tech,
        neon-infused universe. This is your chance to experiment with light,
        color, and composition, transforming digital spaces into scenes full of
        energy and movement.
      </p>
      <br></br>
      <h3>Theme</h3>
      <p>
        <strong>"The Future-Tech Realm: A Digital Frontier"</strong>
      </p>
      <p>
        Designs should reflect a futuristic digital realm characterized by
        glowing grids, sleek cybernetic elements, and immersive, high-tech
        environments. Participants are encouraged to create a visually
        captivating world, combining dynamic lighting, bold colors, and
        imaginative digital structures to tell a story or convey a concept.
      </p>
      <br></br>
      <h3>Participation</h3>
      <ul>
        <li>
          Students from Grade 6–13 of Royal College and other schools are
          eligible to participate.
        </li>
        <li>Individual participation only; no team submissions</li>
        <li>Schools may have multiple participants</li>
        <li>
          Registration for the competition must be completed by the specified
          deadline.
        </li>
        <li>Each participant may submit only one entry</li>
      </ul>
      <br></br>
      <h3>Instructions</h3>
      <ul>
        <li>Only Adobe Photoshop may be used for creating your artwork.</li>
        <li>
          Participants must capture regular process screenshots to document
          their workflow.
        </li>
        <li>
          Artwork should maintain a consistent theme and aesthetic, inspired by
          futuristic digital environments.
        </li>
        <li>
          Templates or pre-made designs are not allowed; originality is
          mandatory.
        </li>
        <li>Any dimensions may be used for the final artwork.</li>
      </ul>
      <br></br>
      <h3>Evaluation & Scoring</h3>
      <ul>
        <li>
          <strong>Concept & Relevance</strong> - How effectively the artwork
          captures the futuristic digital theme
        </li>
        <li>
          <strong>Creativity</strong> - Originality and innovative approach
        </li>
        <li>
          <strong>Visual Appeal</strong> - Composition, color, and lighting
          effects
        </li>
        <li>
          <strong>Technical Skill</strong> - Use of Photoshop tools, layers, and
          techniques
        </li>
        <li>
          <strong>Audience Impact</strong> - Ability of the artwork to engage
          and communicate visually
        </li>
      </ul>
      <br></br>
      <h3>Submission</h3>
      <ul>
        <li>
          Project files to be submitted should Include all layers, textures, and
          assets in a .rar archive.
        </li>
        <li>Final artwork: Export the completed piece as .png or .jpg.</li>
        <li>
          Uploading file should be named in the Format:
          'Photo_SchoolName_YourName.rar'
          <br />- Example: Photo_RoyalCollege_MihinRukshan.rar
        </li>
        <li>
          Upload the Google Drive link of your archive via the official website
          of BTUI'26, setting public access to your archive.
        </li>
        <li>Submissions received after the deadline will not be considered.</li>
      </ul>
    </div>
  );
}

export function PosterDesignDetails() {
  return (
    <div>
      <h2>Poster Design</h2>
      <br></br>
      <h3>Overview</h3>
      <p>
        This Competition will challenge participants to create a bold,
        futuristic graphic poster that captures the essence of the event in a
        "happening now" style. Posters should not only be visually appealing but
        also reflect the dynamic energy, digital aesthetic, and innovative
        spirit of BTUI'26. The best submission may even be featured as part of
        the official announcement of BTUI'26 on the main event day — giving
        participants the chance to see their work showcased to a wide audience.
      </p>
      <br></br>

      <h3>Theme</h3>
      <p>
        <strong>"Happening Now: A Futuristic Call to BTUI'26"</strong>
      </p>
      <p>
        Participants must design a poster styled around the current identity of
        BTUI'26 — a digital frontier of light, innovation, and immersive
        technology. The design should feel present, alive, and event-ready, with
        a look that would make it suitable for actual promotional use.
      </p>
      <br></br>

      <h3>Participation</h3>
      <ul>
        <li>
          Students from Grade 6–13 of Royal College and other schools are
          eligible to participate.
        </li>
        <li>Individual entries only; team participation is not permitted</li>
        <li>Schools may send any number of participants</li>
        <li>
          Registration for the competition must be completed by the specified
          deadline.
        </li>
        <li>Each participant is limited to one poster submission</li>
      </ul>
      <br></br>

      <h3>Instructions</h3>
      <ul>
        <li>
          Participants may use Adobe Photoshop, Illustrator, or any professional
          graphic design software.
        </li>
        <li>
          Designs must represent a "Happening Now" BTUI'26 poster concept.
        </li>
        <li>
          Submissions must be original; plagiarism or use of stock templates
          will lead to disqualification.
        </li>
        <li>
          Posters should maintain a consistent futuristic aesthetic, inspired by
          neon-lit, cyber-infused visual language.
        </li>
        <li>
          Standard poster dimensions are recommended (A3 or A4 portrait), but
          creativity in layout will be valued.
        </li>
      </ul>
      <br></br>

      <h3>Evaluation & Scoring</h3>
      <ul>
        <li>
          <strong>Concept & Relevance</strong> - How effectively the artwork
          captures the futuristic digital theme
        </li>
        <li>
          <strong>Creativity</strong> - Originality and innovative approach
        </li>
        <li>
          <strong>Visual Appeal</strong> - Composition, color, and lighting
          effects
        </li>
        <li>
          <strong>Technical Skill</strong> - Use of design tools, layers, and
          techniques
        </li>
        <li>
          <strong>Audience Impact</strong> - Ability of the artwork to engage
          and communicate visually
        </li>
      </ul>
      <br></br>

      <h3>Submission</h3>
      <ul>
        <li>Poster file: Export the final design in .png or .jpg format.</li>
        <li>
          Editable source file: Submit the working file (.psd, .ai, or
          equivalent) with all layers intact.
        </li>
        <li>
          The file to be uploaded should be named in the Format:
          'Poster_SchoolName_YourName.rar'
          <br />- Example: Poster_RoyalCollege_MihinRukshan.rar
        </li>
        <li>
          Upload the Google Drive link of your archive via the official website
          of BTUI'26, setting public access to your archive.
        </li>
        <li>Submissions received after the deadline will not be considered.</li>
      </ul>
    </div>
  );
}

export function LogoDesignDetails() {
  return (
    <div>
      <h2>Logo Design</h2>
      <br></br>
      <h3>Overview</h3>
      <p>
        Participants should design a futuristic, tech-inspired logo that
        embodies the spirit of innovation, digital transformation, and
        boundary-breaking creativity, suitable for a future tech event.
      </p>
      <br></br>
      <h3>Participation</h3>
      <ul>
        <li>
          Students from Grade 6–13 of Royal College and other schools are
          eligible to participate.
        </li>
        <li>Individual participation only; no team submissions</li>
        <li>Schools may have multiple participants</li>
        <li>
          Registration for the competition must be completed by the specified
          deadline.
        </li>
        <li>Each participant may submit only one entry</li>
      </ul>
      <br></br>
      <h3>Instructions</h3>
      <ul>
        <li>
          Logos must be created digitally using professional design tools such
          as Adobe Illustrator, Photoshop, Figma, or equivalent.
        </li>
        <li>
          Submissions must include both a full-color version and a simplified
          monochrome version.
        </li>
        <li>
          The design should be scalable (e.g., usable on small digital icons and
          large posters).
        </li>
        <li>
          All work must be original; plagiarism and use of stock logo templates
          will lead to disqualification.
        </li>
        <li>
          A short design note must accompany the logo, explaining the
          inspiration and concept.
        </li>
      </ul>
      <br></br>
      <h3>Evaluation & Scoring</h3>
      <ul>
        <li>
          <strong>Concept & Relevance</strong> - How well the logo conveys a
          futuristic and digital-forward identity while aligning with the
          competition's vision.
        </li>
        <li>
          <strong>Creativity</strong> - Freshness of the idea, innovative
          symbolism, and uniqueness of the visual identity.
        </li>
        <li>
          <strong>Simplicity & Memorability</strong> - Ability of the logo to
          remain clear, distinctive, and easily recognizable across contexts.
        </li>
        <li>
          <strong>Versatility</strong> - How effectively the logo adapts across
          mediums and formats (print, digital, monochrome, scaled versions).
        </li>
        <li>
          <strong>Visual Impact</strong> - The immediate impression the logo
          leaves—professionalism, aesthetic balance, and ability to engage the
          audience
        </li>
      </ul>
      <br></br>
      <h3>Submission</h3>
      <ul>
        <li>
          Contestants should export the logo in .png and .jpg formats (colour +
          monochrome versions).
        </li>
        <li>
          Uploading file should be named in the Format:
          'Logo_SchoolName_YourName.rar'
          <br />- Example: Logo_RoyalCollege_MihinRukshan.rar
        </li>
        <li>
          Upload the Google Drive link of your archive via the official website
          of BTUI'26, setting public access to your archive.
        </li>
        <li>Submissions received after the deadline will not be considered.</li>
      </ul>
    </div>
  );
}

export function UIUXDesignDetails() {
  return (
    <div>
      <h2>UI/UX Design</h2>
      <br></br>
      <h3>Overview</h3>
      <p>
        This competition challenges participants to merge creativity with
        functionality by designing a futuristic user interface and user
        experience concept. The aim is to imagine a digital environment that
        feels immersive, seamless, and intuitive—pushing boundaries of how
        humans may interact with systems in the near future.
      </p>
      <br></br>
      <h3>Theme</h3>
      <p>
        <strong>"Beyond the Screen: Envisioning Interactive Futures"</strong>
      </p>
      <p>
        Design a digital productive interface that captures the essence of
        tomorrow's technology—bold, fluid, and adaptive to users' needs in a
        future-tech world.
      </p>
      <br></br>
      <h3>Participation</h3>
      <ul>
        <li>
          Students from Grade 6–13 of Royal College and other schools are
          eligible to participate.
        </li>
        <li>Individual participation only; no team submissions</li>
        <li>Schools may have multiple participants</li>
        <li>Registration must be completed by the specified deadline.</li>
        <li>Each participant may submit only one entry</li>
      </ul>
      <br></br>
      <h3>Instructions</h3>
      <ul>
        <li>
          Participants may use any recognized UI/UX design tools (e.g., Figma,
          Adobe XD, Sketch).
        </li>
        <li>
          The design must include at least one primary interface screen
          (homepage/dashboard/app main screen).
        </li>
        <li>
          Provide a short user flow or wireframe sketch (at least 2–3 connected
          screens).
        </li>
        <li>
          No plagiarism or use of pre-made templates—designs must be original.
        </li>
        <li>
          The interface should demonstrate both aesthetic vision and
          user-centered thinking.
        </li>
      </ul>
      <br></br>
      <h3>Evaluation and Scoring</h3>
      <ul>
        <li>
          <strong>Concept & Innovation</strong> – Originality and futuristic
          vision of the interface.
        </li>
        <li>
          <strong>User Experience</strong> – Intuitiveness, accessibility, and
          clarity of user flow.
        </li>
        <li>
          <strong>Visual Design</strong> – Aesthetics, layout, typography, and
          overall style.
        </li>
        <li>
          <strong>Functionality & Consistency</strong> – Logical structure,
          responsiveness, and design coherence.
        </li>
        <li>
          <strong>Impact & Engagement</strong> – Ability to engage users and
          convey a futuristic digital identity.
        </li>
      </ul>
      <br></br>
      <h3>Submission</h3>
      <p>Contestants should submit the designs in the following format:</p>
      <ul>
        <li>Export interface screens in .png or .jpg.</li>
        <li>
          Provide an interactive prototype link (Figma, Adobe XD, etc.) if
          available.
        </li>
        <li>
          A PDF file including brief concept note (max 200 words), 2–3 wireframe
          sketches/user flows, screenshots of your design process.
        </li>
        <li>
          Upload all the files to a .zip/.rar folder and rename in the Format:
          'UIUX_SchoolName_YourName.rar'
          <br />- Example: UIUX_RoyalCollege_MihinRukshan.rar
        </li>
        <li>
          Upload the Google Drive link of your archive via the official website
          of BTUI'26, setting public access to your archive.
        </li>
        <li>Submissions received after the deadline will not be considered.</li>
      </ul>
    </div>
  );
}

export function LineBotDetails() {
  return (
    <div>
      <h2>Fastest Line-following Bot</h2>
      <br></br>
      <h3>Overview</h3>
      <p>
        This competition is designed to test the speed, precision, knowledge,
        and experience of participants in robotics. Contestants must design and
        build an autonomous bot capable of following a provided marked track
        without any manual intervention. The challenge lies not just in reaching
        the finish line, but in doing so in the fastest time while maintaining
        stability and accuracy throughout the course.
      </p>
      <br></br>
      <h3>Track Details</h3>
      <ul>
        <li>The official competition track will be provided at the venue.</li>
        <li>
          The track will consist of 2 cm wide black lines (+1 mm) on a white
          background, featuring straight paths, curves, 90-degree turns, dead ends,
          and intersections to test adaptability.
        </li>
        <li>
          Ensure the bot fits within the start area (20 cm x 20 cm).
        </li>
        <li>
          Exact dimensions and complexity will be revealed on the competition
          day to ensure fairness.
        </li>
      </ul>
      <br></br>
      <h3>Participation</h3>
      <ul>
        <li>
          Open to students from Grade 6–13 of Royal College and other schools.
        </li>
        <li>
          Teams may consist of a maximum of 4 members from the same school.
        </li>
        <li>Schools may have multiple participants.</li>
        <li>
          Registration for the competition must be completed by the specified
          deadline.
        </li>
        <li>Each team may submit only one bot.</li>
      </ul>
      <br></br>
      <h3>Instructions</h3>
      <ul>
        <li>Each team will be given three attempts.</li>
        <li>The fastest valid run will be considered for scoring.</li>
        <li>
          Teams must report to the testing area at least 15 minutes before their
          scheduled time.
        </li>
        <li>
          Modifications are allowed only before the first attempt; no hardware
          replacements or modifications will be permitted after the trial runs.
        </li>
      </ul>
      <br></br>
      <h3>Evaluation & Scoring</h3>
      <ul>
        <li>
          <strong>Speed</strong> – Fastest completion time.
        </li>
        <li>
          <strong>Accuracy</strong> – Ability to stay on track without manual
          resets.
        </li>
        <li>
          <strong>Design & Engineering</strong> – Quality of build, circuit
          design, and innovation.
        </li>
        <li>
          <strong>Stability & Control</strong> – Smoothness in turns, curves,
          and intersections.
        </li>
      </ul>
      <br></br>
      <h3>Submission</h3>
      <p>Teams must submit a Google Drive folder including:</p>
      <ul>
        <li>
          <strong>Bot Details Document:</strong>
          <ul>
            <li>Team and school details</li>
            <li>Components and sensors used</li>
            <li>Microcontroller and motor driver used</li>
            <li>Approximate dimensions</li>
            <li>Power source and battery type</li>
            <li>Other relevant technical specifications</li>
          </ul>
        </li>
        <li>
          <strong>Demonstration Video:</strong>
          <ul>
            <li>
              A short video demonstrating the bot running successfully on the track.
            </li>
            <li>
              The video should clearly show the bot following the track without
              manual intervention.
            </li>
            <li>No cuts or edits are allowed after the bot starts running.</li>
            <li>The video must be no longer than 7 minutes.</li>
          </ul>
        </li>
        <li>
          Submit through the dedicated page on the official BTUI'26 website
          setting public access to the Google Drive folder.
        </li>
        <li>
          No pre-submission of code or schematics is required, but teams should
          be ready to explain their design if requested.
        </li>
        <li>
          Bots will be tested only on the official track provided on the
          physical day of the main event.
        </li>
      </ul>
    </div>
  );
}

export function InnovationChallengeDetails() {
  return (
    <div>
      <h2>Innovation Challenge</h2>
      <br></br>
      <h3>Overview</h3>
      <p>
        This Challenge is designed to inspire students to tackle real-world
        problems through technologies such as IoT, robotics, and embedded
        systems. Participants are encouraged to think beyond the classroom and
        develop innovative solutions that could improve the safety, resilience,
        and quality of life of communities and cities.
      </p>
      <p>
        The challenge focuses on building a{" "}
        <strong>Disaster-Resilient Smart City System</strong> — a project that
        combines creativity, technical knowledge, engineering skills, and
        problem-solving to address one of humanity's most pressing concerns:
        keeping people safe before, during, and after natural disasters.
      </p>
      <br></br>
      <h3>Problem Statement</h3>
      <p>
        Natural disasters such as floods, landslides, fires, and earthquakes can
        disrupt communities, damage infrastructure, and put thousands of lives
        at risk. Urban areas can be particularly vulnerable due to high population
        density, limited preparedness, and the lack of effective early-warning
        and response systems.
      </p>
      <p>
        The challenge for participants is to design and build a smart,
        affordable, and scalable system that can help communities detect risks,
        respond quickly, and become more resilient during disasters.
      </p>
      <p>Your system should:</p>
      <ul>
        <li>
          Monitor and detect risks using sensors such as water-level, gas,
          vibration, fire, temperature, or other relevant sensors.
        </li>
        <li>
          Communicate real-time alerts to citizens, schools, emergency teams, or
          other relevant parties through IoT connectivity, mobile applications,
          display systems, alarms, or similar technologies.
        </li>
        <li>
          Automate responses where possible, such as emergency evacuation
          alerts, smart barriers, fire suppression mechanisms, emergency
          lighting, or other appropriate safety measures.
        </li>
        <li>
          Demonstrate practicality and creativity, showing how even a
          small-scale prototype could be developed into a practical solution for a
          real-world city or community.
        </li>
      </ul>
      <br></br>
      <h3>Participation</h3>
      <ul>
        <li>
          Open to students from Grade 6–13 of Royal College and other schools.
        </li>
        <li>Teams may consist of a maximum of 4 members from the same school.</li>
        <li>Schools may have multiple participants.</li>
        <li>Each team may submit only one project.</li>
        <li>Registration must be completed before the specified deadline.</li>
      </ul>
      <br></br>
      <h3>Instructions</h3>
      <ul>
        <li>
          The project must be originally designed and developed by the
          participating team.
        </li>
        <li>
          Prototypes must be safe to demonstrate (avoid hazardous materials,
          high voltages, unsafe chemicals, or other dangerous components and
          procedures).
        </li>
        <li>
          Although the prototype may be small-scale, participants should explain
          how the proposed system could be expanded and implemented in a
          real-world environment.
        </li>
        <li>
          Participants are encouraged to use low-cost, widely available, and
          practical components wherever possible.
        </li>
        <li>
          Collaboration and equal contribution from all team members are
          encouraged and will be considered during evaluation.
        </li>
      </ul>
      <br></br>
      <h3>Evaluation & Scoring</h3>
      <ul>
        <li>
          <strong>Creativity & Practical Implementability</strong> - Originality
          of the idea, relevance to disaster resilience, effectiveness of the
          proposed solution, and feasibility of real-world implementation.
        </li>
        <li>
          <strong>Design & Engineering</strong> - Quality and reliability of the
          prototype, efficiency of the circuit and system design, and innovative
          use of hardware and software.
        </li>
        <li>
          <strong>Technical Skills</strong> - Effective application of IoT,
          robotics, embedded systems, sensors, communication technologies, and
          related technical concepts.
        </li>
        <li>
          <strong>Additional Features</strong> - Integration of features such as
          mobile/web applications, data visualization, automation, artificial
          intelligence, or machine learning to improve the system's
          capabilities and decision-making.
        </li>
        <li>
          <strong>Presentation & Communication</strong> - Clarity of the project
          explanation, documentation, demonstration, and video presentation.
        </li>
      </ul>
      <br></br>
      <h3>Submission Requirements</h3>
      <p>
        Each team must submit a public Google Drive folder through the official
        BTUI'26 website submission page containing the following items:
      </p>

      <h4>1. Project Documentation</h4>
      <ul>
        <li>A detailed description of the proposed solution.</li>
        <li>A list of technologies and platforms used.</li>
        <li>A list of hardware components used.</li>
        <li>
          A system overview, including a flowchart, block diagram, and/or
          circuit diagram.
        </li>
        <li>
          The complete source code containing all implemented features and
          functionalities.
        </li>
        <li>A short and clear explanation of how the system operates.</li>
      </ul>

      <h4>2. Demonstration Video</h4>
      <ul>
        <li>
          A simple demonstration video showing the system in action.
        </li>
        <li>A clear explanation of the proposed solution.</li>
        <li>A demonstration of the system's main functionality.</li>
        <li>A demonstration of key features and responses.</li>
        <li>
          An explanation of how the system could be applied or scaled for
          real-world use.
        </li>
      </ul>
    </div>
  );
}

export function QuizChallengeDetails() {
  return (
    <div>
      <h2>Quiz</h2>
      <br></br>
      <h3>Overview</h3>
      <p>
        The Orthodox (Quiz) competition is a knowledge-driven challenge that
        tests students on a wide range of ICT topics, including fundamentals,
        emerging technologies, digital ethics, and industry trends. The quiz
        will be conducted in two online rounds followed by a final physical
        round at BTUI'26, where the top performers will compete for the
        championship.
      </p>
      <br></br>
      <h3>Participation</h3>
      <ul>
        <li>
          Students of Grades 10-13 from schools across Sri Lanka are allowed to
          participate.
        </li>
        <li>
          Eligible for Teams only; no individual or mixed-school entries are
          allowed
        </li>
        <li>Maximum of 5 members are allowed for each team.</li>
        <li>
          All team members must be enrolled in the specific participating school
        </li>
        <li>
          Registration for the quiz competition must be completed by the
          specified deadline.
        </li>
        <li>Only two teams per school.</li>
      </ul>
      <br></br>

      <h3>Competition Format</h3>

      <h4>Round 1 – Online Preliminary</h4>
      <ul>
        <li>Conducted online via the official BTUI'26 quiz portal</li>
        <li>
          Consists of a mix of Multiple Choice Questions (MCQs) and short-answer
          challenges
        </li>
        <li>
          Teams will work together in Zoom Breakout Rooms with collaboration.
        </li>
        <li>
          Duration & timing will be informed to participants prior to the round
        </li>
        <li>
          Teams will be ranked based on their cumulative score, with the top 8
          teams advancing to the semifinal
        </li>
      </ul>
      <br></br>

      <h4>Round 2 – Online Semifinal</h4>
      <ul>
        <li>Conducted online via the BTUI'26 quiz portal</li>
        <li>
          Consists of Advanced MCQs and scenario-based questions to test
          analytical and technical reasoning
        </li>
        <li>
          Teams continue to work in assigned Zoom Breakout Rooms
          collaboratively.
        </li>
        <li>
          Details regarding duration & timing will be provided before the round
        </li>
        <li>
          Teams will be ranked according to their total score, with the top 2
          teams qualifying for the final round.
        </li>
      </ul>
      <br></br>

      <h4>Final Round – Physical at BTUI'26 main event</h4>
      <ul>
        <li>
          The final round will be held onsite during main event of BTUI'26
        </li>
        <li>
          The top 2 teams from the semifinal round conducted online will be
          selected for the final round.
        </li>
        <li>
          Questions will cover:
          <ul style={{ marginLeft: "1.5rem" }}>
            <li>ICT concepts from Advanced and Ordinary Level syllabus</li>
            <li>Programming logic and problem-solving</li>
            <li>General technology and innovation knowledge</li>
          </ul>
        </li>
        <li>
          <strong>Format:</strong> An interactive quiz featuring live scoring
          and innovative elements, and unique features never seen before.
        </li>
      </ul>
      <br></br>

      <h3>Online Round Guidelines</h3>
      <ul>
        <li>
          Teams must ensure reliable access to Zoom and the BTUI'26 quiz portal
          prior to the quiz rounds.
        </li>
        <li>
          All team members must have functioning cameras and microphones on
          throughout the round
        </li>
        <li>
          Any form of cheating or using of external sources will lead to
          immediate disqualification
        </li>
      </ul>
      <br></br>
      <h3>Code of Conduct</h3>
      <ul>
        <li>
          <strong>Team Communication:</strong> Only between registered team
          members within breakout rooms
        </li>
        <li>Organizers will actively monitor all breakout rooms</li>
        <li>
          Violation of rules or dishonest conduct results in disqualification
        </li>
        <li>
          <strong>Time Limit per Question:</strong> Each question has a preset
          time; answers submitted after the time expires will not be counted
        </li>
        <li>
          <strong>Late Access:</strong> Teams unable to join within the
          scheduled time may be disqualified
        </li>
      </ul>
      <br></br>
      <h3>Technical Requirements</h3>
      <ul>
        <li>
          Each participant must have a working device with camera, microphone,
          and stable internet
        </li>
        <li>
          Teams must ensure access to Zoom and the BTUI'26 quiz portal without
          technical issues
        </li>
      </ul>
    </div>
  );
}

export function MostPopularICTSocietyDetails() {
  return (
    <div>
      <h2>Most Popular ICT Society</h2>
      <br></br>
      <h3>Eligibility</h3>
      <ul>
        <li>
          All school ICT societies across the island are invited to participate
          in this challenge to showcase their community spirit and popularity.
        </li>
      </ul>
      <br></br>
      <h3>Registration Requirement</h3>
      <ul>
        <li>
          Only the top four positions of the society (President, Vice President,
          Secretary, Treasurer) or the Teacher-in-Charge may proceed with the
          registration process.
        </li>
        <li>
          Submissions from other members will be automatically disregarded.
        </li>
      </ul>
      <br></br>
      <h3>Post Publication</h3>
      <ul>
        <li>
          After registration, a dedicated post for each participating school
          will be published on the Royal College Computer Society WhatsApp
          channel.
        </li>
        <li>
          Posts will include the school name, society details, and any creative
          content submitted during registration.
        </li>
      </ul>
      <br></br>
      <h3>Voting Process</h3>
      <p>
        Voting for the competition will be conducted through multiple social
        media platforms to ensure wider engagement and visibility. Each school's
        post will be shared across WhatsApp, Instagram, and Facebook, and votes
        will be calculated based on the following point system:
      </p>
      <ul>
        <li>
          <strong>WhatsApp Reaction</strong> – 5 points
        </li>
        <li>
          <strong>Instagram Like</strong> – 5 points
        </li>
        <li>
          <strong>Instagram Share</strong> – 10 points
        </li>
        <li>
          <strong>Instagram Repost</strong> – 15 points
        </li>
        <li>
          <strong>Facebook Like</strong> – 5 points
        </li>
      </ul>
      <p>
        The total score will be determined by the cumulative points earned from
        all platforms.
      </p>
      <p>Voting will begin immediately after the posts are published.</p>
      <br></br>
      <h3>Voting Period</h3>
      <ul>
        <li>
          The voting window will remain open for a pre-determined duration,
          which will be communicated at the time of post publication.
        </li>
        <li>
          Only reactions received within the voting period will be counted.
        </li>
      </ul>
      <br></br>
      <h3>Winner Selection</h3>
      <p>
        The school whose post receives the highest number of red heart reactions
        by the voting deadline will be declared as the winner of the Most
        Popular ICT Society award.
      </p>
      <br></br>
      <h3>Disclaimer</h3>
      <ul>
        <li>
          Any attempt to artificially inflate reactions, use bots, or manipulate
          votes will lead to immediate disqualification.
        </li>
        <li>
          The decision of the organizing committee will be final and binding.
        </li>
      </ul>
    </div>
  );
}

export function OverallChampionshipDetails() {
  return (
    <div>
      <h2>Overall Championship</h2>
      <br></br>
      <p>
        BTUI 2026 introduces the Overall Championship Award, recognizing the
        school that demonstrates outstanding performance and participation
        across all competitions.
      </p>
      <br></br>
      <h3>Scoring System</h3>
      <ul>
        <li>
          Each valid submission for any competition will earn the respective
          school <strong>50 points</strong>.
        </li>
      </ul>
      <br></br>
      <h4>For Individual Competitions:</h4>
      <ul>
        <li>
          1st Place: <strong>300 points</strong>
        </li>
        <li>
          2nd Place: <strong>200 points</strong>
        </li>
        <li>
          3rd Place: <strong>100 points</strong>
        </li>
      </ul>
      <br></br>
      <h4>For Team Competitions:</h4>
      <ul>
        <li>
          1st Place: <strong>600 points</strong>
        </li>
        <li>
          2nd Place: <strong>500 points</strong>
        </li>
        <li>
          3rd Place: <strong>400 points</strong>
        </li>
      </ul>
      <br></br>
      <p>
        The total score of each school will be calculated based on both
        submissions and placement points. The school achieving the highest
        cumulative score will be crowned the{" "}
        <strong>Overall Champion of BTUI 2026</strong>.
      </p>
      <br></br>
      <p>
        This championship not only celebrates victory but also acknowledges
        consistent participation, collaboration, and enthusiasm — the true
        essence of Beyond the User Interface 2026.
      </p>
    </div>
  );
}
